import { connect } from 'react-redux'
import CreateDCFPage from '../components/CreateDCFPage'
import { actions } from '../modules/CreateDCF'

const mapStateToProps = ({ createDcf, loading }) => {
  return {
    step: createDcf?.step || 1,
    participants: createDcf?.participants || [],
    instruments: createDcf?.instruments || [],
    instances: createDcf?.instances || [],
    answers: createDcf?.answers || [],
    selectedParticipant: createDcf?.selectedParticipant,
    selectedInstrument: createDcf?.selectedInstrument,
    selectedInstance: createDcf?.selectedInstance,
    selectedAction: createDcf?.selectedAction || 'add_data_to_existing_record',
    instrumentVersion: createDcf?.instrumentVersion || '',
    startedBy: createDcf?.startedBy || '',
    completedBy: createDcf?.completedBy || '',
    // Participants use loadingKey 'participant'; other DCF calls use general.
    loading: !!(loading?.general || loading?.participant),
  }
}

const mapDispatchToProps = { ...actions }

export default connect(mapStateToProps, mapDispatchToProps)(CreateDCFPage)
